import _ from 'lodash'
import Backbone from 'backbone'
import MarkedField from 'scoreboard/components/marked-field'
import requiredValidator from 'scoreboard/components/validators/required-validator'

//Base Form view for reports, holds all the common elements for a report form
var BaseReportForm = Backbone.View.extend({

	_initLabelField: function() {
		if (this.label) {
			this.label.remove()
		}
		var text = this.$('.report-info input:text')

		if (this.model.isEditable()) {
			this.label = new MarkedField({
				el: text,
				validator: requiredValidator
			}).render()
		} else {
			text.prop('readonly', true)
		}
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.label], 'remove')
	}

})

export default BaseReportForm

BaseReportForm.__filename__ = 'reports/common/base-report-form.js'
